/** Used for the Productivity Methods. */

import { type TFunction } from 'i18next'
import { supportedLanguages } from 'services/productivity-methods/consts'
import slugify from 'slugify'

const translationRegex = /"|'|,|—|\.|:|\/|\\|<|>|\+|…|#|~|=|’|\s|u&#39;|“|”|\(|\)|&/g

export function dynamicTranslate(text: string, t: TFunction, locale: string) {
    // We only translate the productivity methods in the following languages.
    if (!supportedLanguages.includes(locale)) return text
    if (!text || !text.trim()) return text
    const key = slugify(text.replace(translationRegex, '').slice(0, 100))

    let normalizedText = text.replaceAll('&#x27;', '’')
    if (normalizedText.startsWith('&quot;')) {
        normalizedText = normalizedText.replace('&quot;', '“')
    }
    if (normalizedText.endsWith('&quot;')) {
        normalizedText = normalizedText.replace(/&quot;$/, '”')
    }

    //.replaceAll('&quot;', '"')
    return t(key, { defaultValue: normalizedText })
}
